import React, { Fragment, FunctionComponent } from "react";
import styles from "./Toolbar.module.scss";
import ToolbarProps from "./ToolbarProps.interface";

import LocationSelector from "./components/LocationSelector/LocationSelector";
import setToolbarStyles from "./hooks/setToolbarStyles";

import Anchor from "components/Anchor/Anchor";
import Button from "components/Button/Button";
import IconViewer from "components/IconViewer/IconViewer";
import useWindowDimensions from "hooks/useWindowDimensions";

const Toolbar: FunctionComponent<ToolbarProps> = (props) => {
    const { width } = useWindowDimensions();

    let toolbar: any;
    if (props.settings?.theme?.toolbar?.[0] && props.settings.theme.toolbar.length > 0) {
        toolbar = props.settings.theme.toolbar[0]?.content;
    }

    const toolbarStyles = setToolbarStyles(toolbar);

    if (width >= 570 || ((!props.settings.toolbarMenu || props.settings.toolbarMenu.length === 0) && (!props.settings.locations || props.settings.locations.length === 0) && (!props.settings.toolbarButtons || props.settings.toolbarButtons.length === 0))) {
        return (
            <Fragment></Fragment>
        );
    }

    return (
        <div className={styles.wrapper} style={toolbarStyles}>
            <div className={styles.inner}>
                {/* Links */}
                {props.settings.toolbarMenu && props.settings.toolbarMenu.length > 0 ? (
                    <div className={styles.links}>
                        {props.settings.toolbarMenu.map((item: any, index: number) => {
                            return (
                                <Anchor key={index} className={styles.link} to={item.content.link}>
                                    <IconViewer className={styles.link_icon} name={item.content.icon} />
                                    <span>{item.content.label}</span>
                                </Anchor>
                            );
                        })}
                    </div>
                ) : null}

                {/* Location Selector */}
                {props.settings?.locations && props.settings.locations.length > 0 ? (
                    <LocationSelector locations={props.settings.locations} />
                ) : null}

                {/* Button */}
                {props.settings.toolbarButtons && props.settings.toolbarButtons.length > 0 ? (
                    <div className={styles.buttons}>
                        {props.settings.toolbarButtons.map((button: any, index: number) => {
                            return (
                                <Button key={index} to={button.content.link} className={styles.button} contentType={"blockButton1"} {...button.content}>
                                    {button.content.label}
                                </Button>
                            );
                        })}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default Toolbar;